import ViewRaportyList from "../../components/views/raporty/oper/ViewRaportyList/ViewRaportyList.jsx";
import ViewRaportForm from "../../components/views/raporty/oper/ViewRaportForm/ViewRaportForm.jsx";

export const raportyRoutes = [
    {
        path: `/oper/raporty`,
        exact: true,
        roles: [`raporty_podglad`],
        forbidden: true,
        view: <ViewRaportyList />,
        mode: `any`,
    },
    {
        path: `/oper/raporty/nowy`,
        exact: true,
        roles: [`raporty_modyfikacja`],
        forbidden: true,
        view: <ViewRaportForm />,
        mode: `any`,
    },
    {
        path: `/oper/raporty/:id`,
        exact: true,
        roles: [`raporty_modyfikacja`],
        forbidden: true,
        view: <ViewRaportForm />,
        mode: `any`,
    },
]